<template>
  <div>
    <div class="search-section">
      <div class="search-wrapper" @click="handleSearchInputFakeClick">
        <img class="location-icon" src="@assets/images/location.png" alt="" />
        <div
          class="search-input-fake"
          :style="[keywords && { color: '#212121' }]"
        >
          {{ keywords ? keywords : "请输入您的收货地址" }}
        </div>
      </div>
    </div>
    <div class="location-choosed" @click="linkBack">
      <img
        class="location-icon"
        src="@assets/images/location-orange.png"
        alt=""
      />
      <div>送至：</div>
      <div>{{ location.addrInfo.address || "" }}</div>
    </div>

    <div class="poi-section" v-show="location.pois && location.pois.length > 0">
      <div class="section-title">附近地址</div>
      <div class="poi-list">
        <div
          class="poi-item"
          v-for="(poiItem, index) in location.pois"
          :key="poiItem.id"
          @click="chooseAddr(poiItem)"
        >
          <div>{{ poiItem.name }}</div>
          <div
            class="relocation c-brand"
            v-if="index === 0"
            @click.stop="getLocation"
          >
            <img
              class="location-icon"
              src="@assets/images/dingwei.png"
              alt=""
            />
            <div>重新定位</div>
          </div>
        </div>
      </div>
    </div>

    <div class="search-popup" v-show="popupShow" @click="popupShow = false">
      <div class="search-section" @click.stop>
        <div class="search-wrapper">
          <img class="location-icon" src="@assets/images/location.png" alt="" />
          <input
            ref="searchInput"
            class="search-input"
            placeholder="请输入您的收货地址"
            v-model="keywords"
            @input="handleSearchInput"
          />
          <img
            v-if="keywords"
            class="delete-icon"
            src="@assets/images/delete.png"
            alt=""
            @click="deleteInput"
          />
        </div>
        <div
          style="padding: 0.04rem 0.1rem; margin-left: 0.1rem; font-size: 0.28rem;"
          @click.stop="popupShow = false"
        >
          取消
        </div>
      </div>
      <div
        class="search-result"
        @click.stop
        v-show="searchResult && searchResult.length > 0"
      >
        <div
          class="result-item"
          v-for="item in searchResult"
          :key="item.id"
          @click="chooseAddr(item)"
        >
          <div class="name">{{ item.name }}</div>
          <div class="addr">{{ item.address }}</div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import mapService from "@libs/mapService";
export default {
  data() {
    return {
      keywords: "",
      isSearchInputFocus: false,
      searchResult: [],
      popupShow: false
    };
  },

  computed: {
    location() {
      return this.$store.state.app.location;
    }
  },

  methods: {
    handleSearchInput() {
      clearTimeout(this._searchInputTimer);
      this._searchInputTimer = setTimeout(() => {
        this.searchLocation();
      }, 600);
    },

    searchLocation() {
      if (!this.keywords) return;
      this.$dialog.loading.open();
      mapService
        .search(this.keywords, this.location.addrInfo.city)
        .then(res => {
          this.searchResult = res.data || [];
          this.$dialog.loading.close();
        })
        .catch(e => {
          this.$dialog.loading.close();
          console.error(e);
        });
    },

    getLocation() {
      this.$dialog.loading.open();
      mapService
        .getLocation()
        .then(res => {
          const latLng = { latitude: res.latitude, longitude: res.longitude };
          this.$store.commit("UPDATE_LOCATION", {
            latLng
          });
          return mapService.reverseGeocoder(latLng, 1);
        })
        .then(res => {
          let pois = res.regeocode.pois || [];
          pois = pois.slice(0, 4);
          const addressComponent = res.regeocode.addressComponent;
          const cityname =
            typeof addressComponent.city === "string"
              ? addressComponent.city
              : addressComponent.province;
          pois.forEach(item => {
            item.cityname = cityname;
          });
          this.$store.commit("UPDATE_LOCATION", {
            pois
          });
          this.$dialog.loading.close();
        })
        .catch(e => {
          console.error(e);
          this.$dialog.loading.close();
        });
    },

    linkBack() {
      this.$router.go(-1);
    },

    handleSearchInputFakeClick() {
      this.popupShow = true;
      this.$nextTick(() => {
        this.$refs.searchInput.focus();
      });
    },

    deleteInput() {
      this.keywords = "";
      this.searchResult = [];
    },

    chooseAddr(addrInfo) {
      this.$store.commit("UPDATE_LOCATION", {
        addrInfo
      });
      this.popupShow = false;
      this.keywords = "";
      this.$router.go(-1);
    }
  }
};
</script>
<style scoped>
.search-section {
  flex: 0 0 auto;
  display: flex;
  align-items: center;
  padding: 0.2rem;
  background: #fff;
  position: relative;
}

.search-wrapper {
  overflow: hidden;
  flex: 1 1 auto;
  box-sizing: border-box;
  display: flex;
  align-items: center;
  padding: 0.08rem 0.2rem;
  height: 0.6rem;
  background: #efefef;
  border-radius: 0.3rem;
  color: #999;
}

.location-icon {
  width: 0.3rem;
  height: 0.3rem;
  margin-right: 0.1rem;
  flex: 0 0 auto;
}

.search-input-fake {
  flex: 1 1 auto;
  color: #999;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}

.delete-icon {
  width: 0.3rem;
  height: 0.3rem;
  flex: 0 0 auto;
  margin-left: 0.1rem;
}

.search-input {
  flex: 1 1 auto;
}

.location-choosed {
  display: flex;
  align-items: center;
  padding: 0.2rem;
  background: lightyellow;
  font-size: 0.24rem;
  color: #ff6701;
}

.poi-section {
  margin-top: 0.2rem;
}

.poi-section .section-title {
  padding: 0 0.2rem 0.1rem;
  line-height: 2;
  color: #999;
  font-size: 0.24rem;
}

.poi-list {
  background: #fff;
  padding: 0 0.2rem;
  color: #212121;
  font-size: 0.28rem;
}

.poi-list .poi-item {
  display: flex;
  justify-content: space-between;
  align-items: center;
  line-height: 1.5;
  border-bottom: 1px solid #ececec;
  overflow: hidden;
  padding: 0.2rem 0;
}

.relocation {
  flex: 0 0 auto;
  display: flex;
  align-items: center;
  font-size: 0.24rem;
}

.add-address-btn {
  flex: 1 1 auto;
  text-align: center;
  height: 0.86rem;
  line-height: 0.86rem;
  border-radius: 0.43rem;
  font-size: 0.32rem;
  color: #fff;
}

.search-popup {
  position: fixed;
  left: 0;
  top: 0;
  z-index: 99;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  flex-direction: column;
}

.search-result {
  flex: 1 1 auto;
  overflow: auto;
  padding: 0 0.2rem;
  background: #fff;
}

.result-item {
  border-bottom: 1px solid #ececec;
  padding: 0.2rem 0;
  line-height: 1.5;
}

.result-item .name {
  font-size: 0.28rem;
  color: #212121;
  white-space: wrap;
}

.result-item .addr {
  font-size: 0.24rem;
  color: #999;
  white-space: wrap;
}
</style>
